export const FIELDS_TYPE_KEYS = {
  FIRST_NAME: 'FIRST_NAME',
  LAST_NAME: 'LAST_NAME',
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER'
} as const
